import { render, staticRenderFns } from "./StaffIndex.vue?vue&type=template&id=28083ddf"
import script from "./StaffIndex.vue?vue&type=script&lang=js"
export * from "./StaffIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports